import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { ListBox as AriaListBox, ListBoxProps } from "react-aria-components";

export function _ListBox<T extends object>(props: ListBoxProps<T>) {
  return (
    <AriaListBox
      {...mergeProps(props, {
        className: styles.listBox,
      })}
    />
  );
}

const styles = {
  listBox: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
    marginTop: "var(--space-1)",
    marginBottom: "var(--space-1)",
    outline: "none",
    flex: 1,
    overflowX: "auto",
    header: { color: "var(--text-weak)" },

    "&[data-focus-visible]": {
      boxShadow: "var(--focus-action)",
    },

    ":not(:has(section))": {
      padding: "var(--space-1)",
    },
  }),
};
